import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSelectModule } from '@angular/material/select';
import { ListDisplayStudentModule } from '../../list-display/list-display-student/list-display-student.module';
import { ListSearchModule } from '../../list-search/list-search.module';
import { SharedServicesModule } from './../../../../shared/services/shared.services.module';
import { AcademicMadLib } from './academic-mad-lib.component';

@NgModule({
  declarations: [AcademicMadLib],
  imports: [
    SharedServicesModule,
    CommonModule,
    MatExpansionModule,
    MatSelectModule,
    MatGridListModule,
    ListDisplayStudentModule,
    MatMenuModule,
    FormsModule,
    ListSearchModule,
  ],
  exports: [AcademicMadLib],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AcademicMadLibModule {
  /** */
}
